import { post,get,put } from "../api_helper";
 import { RECURITLOGIN,RECURITVERIFY } from "../url_helper";

 
 
 
 export const createloginRecurit =(payload)=> post(`${RECURITLOGIN}`,payload);
 export const otpverifyRecurit =(payload)=> post(`${RECURITVERIFY}`,payload);
 